import { useEffect } from 'react'
import CustomHead from 'components/commons/CustomHead'
import Template from 'components/cases/listpage/productManagement/Template'

const ProductManagement: React.FC = () => {
  useEffect(() => {
    document.querySelector('body').classList.remove('non-chat')
  }, [])
  return (
    <>
      <CustomHead
        keyword={
          'プロダクト開発 PMO PM プロジェクト管理 ビジネス要求定義'
        }
        image={'https://www.i3design.jp/OGP_logo.png'}
        url={'https://www.i3design.jp/cases/product-management'}
        title="プロダクトマネジメント | 事例 | i3DESIGN アイスリーデザイン"
        description="プロダクトマネジメントサービスのケーススタディを紹介します｜i3DESIGNはビジネス・デザイン・テクノロジーの力を駆使して、顧客のミッションをあらゆる角度から伴走支援するデジタルイノベーションパートナー事業を展開しています。"
      />
      <Template />
    </>
  )
}

export default ProductManagement
